import { render, staticRenderFns } from "./TableBubbleMeasurments.vue?vue&type=template&id=0f3168d5&scoped=true"
import script from "./TableBubbleMeasurments.vue?vue&type=script&lang=js"
export * from "./TableBubbleMeasurments.vue?vue&type=script&lang=js"
import style0 from "./TableBubbleMeasurments.vue?vue&type=style&index=0&id=0f3168d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3168d5",
  null
  
)

export default component.exports